import { getOptionName, getOptionDescription } from '../formUtils';
import { FormFieldComponentProps } from './fieldProps';

const RadioButtonListField = ({ field, value, disabled, onChange, onBlur }: FormFieldComponentProps) => {
	const isRowLayout = field.settings.optionsinrow === true;

	return (
		<div onBlur={onBlur}>
			{field.label && <div className='biz-form-field__label'>{field.label}</div>}
			<div className={`biz-form-field__options ${isRowLayout ? 'biz-form-field__options--row' : ''}`} role='radiogroup'>
				{field.options.map((option) => {
					const name = getOptionName(option.translations);
					const description = getOptionDescription(option.translations);
					const optionId = String(option.id);
					const isChecked = value === optionId;

					return (
						<label
							key={optionId}
							className={`biz-form-field__option ${isChecked ? 'biz-form-field__option--selected' : ''}`}
						>
							<input
								type='radio'
								name={field.key}
								checked={isChecked}
								onChange={() => onChange(optionId)}
								disabled={disabled}
							/>
							<div>
								<span className='biz-form-field__option-label'>{name}</span>
								{description && <div className='biz-form-field__option-description'>{description}</div>}
							</div>
						</label>
					);
				})}
			</div>
		</div>
	);
};

export default RadioButtonListField;
